<div class="card mt-4">
  <div class="card-header card-header-danger">
    <h4 class="card-title">Missing URLs</h4>
    <p class="card-category">Registry URLs that are NOT present in the sitemap</p>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="text-danger">
          <th>Path</th>
          <th>City</th>
          <th>Service</th>
          <th>Type</th>
          <th>Actions</th>
        </thead>
        <tbody>
          <tr *ngFor="let m of urls">
            <td>{{ m.urlPath }}</td>
            <td>{{ m.city }}</td>
            <td>{{ m.service }}</td>
            <td>{{ m.type }}</td>
            <td>
              <a [href]="m.url" target="_blank" class="btn btn-link btn-info btn-just-icon">
                <i class="material-icons">open_in_new</i>
              </a>
            </td>
          </tr>
          <tr *ngIf="!urls || urls.length === 0">
            <td colspan="5" class="text-center py-4 text-muted">No missing URLs found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
